import Banner from './Banner';
import Paper from './Paper';
import Footer from './Footer';

function App() {
  return (
    <div className="rootGrid">
      <Banner />
      <Paper />
      <Footer />
    </div>
  );
}

export default App;
